import React, { Component, Fragment } from 'react';
import * as accountForm from './data/dataForAccounts';
import _ from 'lodash';
import styled from 'styled-components';
import { StyledForm } from './styles/main';
import { withRouter } from 'react-router-dom';
import * as preData from './data/prepopulate.data';
import { SvgIcons } from 'synapsefi-dev-ui';
import * as utils from './utils';
import * as VN from './constants/VendorNames';
import AccountResponse from './components/AccountResponse';
import AccountSideNav from './components/AccountSideNav';
import BrandSection from './components/BrandSection';
import HeaderText from '../../common/HeaderText';
import Colors from '../../../constants/colors';
import * as ff from './constants/FormFields';
import { CSSTransition } from 'react-transition-group';
import ModalForm from './components/ModalForm';
import PinModal from '../../common/PinModal/PinModal';

const AccountFormContainer = styled.div`
    display: grid;
    grid-template-columns: 178px 548px;
    border-radius: 5px;
    background: ${Colors.WHITE};
    border: 1px solid ${Colors.SEPARATOR_GRAY};
    position: relative;
    margin: 0 auto;
    height: 516px;

    ${props => props.isSubmitted ? `
        grid-template-columns: 1fr;
        max-width: initial;
        width: 415px;
        box-sizing: border-box;
        padding: 10px 10px;
        height: 410px;
        justify-content: center;
        align-items: stretch;
    ` : `
        width: auto;
    `}

    ${props => props.isLoading && `display: none;`}

    .Button__Submi .syn-dev-ui-button-focus-container {
        &:hover {
            background: ##757575;
        }
    }
`;

const AccountFormGrid = styled.div`
    position: relative;
`;

const LoaderWrapper = styled.div`
    margin-top: 10%;
    opacity: 0;
    transition: .3s ease opacity;

    ${props => props.isLoading && `opacity: 1;`}
`;

const ButtonGroup = styled.div`
    margin-bottom: 20px;
    margin-right: 20px;
    display: flex;
    justify-content: flex-end;
`;

const AnchorText = styled.span`
    font-family: Nunito Sans;
    font-size: 14px;
    font-style: normal;
    font-weight: normal;
    text-decoration: underline;
    color: #6C6C6C;

    &:hover {
        color: ${Colors.DARK_NIGHT};
        cursor: pointer
    }
`;

class AccountForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            hasError: false,
            isLoading: false,
            isCharged: false,
            isSubmitted: false,
            isAdvance: false,
            isForeign: false,
            isPreAuth: false,
            showModal: false,
            showPinModal: false,
            isTransitioned: false,
            showSubmit: true,
            customErrors: null,
            showAddressField: false,
            currentRoute: 'custom',
            vendor: 'CUSTOM',
            prevRoute: '',
            currFields: accountForm.allFormFields,
            formValues: accountForm.initialForm,
            ...accountForm.initialForm
        }

        this.form = React.createRef();
    }

    componentDidMount() {
        this.updateFormFields();
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.location.pathname !== prevProps.location.pathname) {
            this.updateFormFields(this.props.location.pathname);
            this.setState({ isTransitioned: true });

            if (this.state.isSubmitted) {
                this.handleReset();
            }
        }
    }

    setPreAuth = (status = false) => {
        this.setState({
            isPreAuth: status
        });
    }

    getRoute(path) {
        if (path.includes("/v1/accounts/")) {
            const route = path.split("/v1/accounts/")[1];
            return route;
        } else {
            return path;
        }
    }

    getRouteType(vendor) {
        const physical = [VN.GAS_STATION, VN.WHOLE_FOODS, VN.ATM];
        const virtual = [VN.VENMO, VN.PAYPAL, VN.AMAZON, VN.GREEN_DOT, VN.UBER, VN.RESTAURANT];
        let routeType = 'custom';

        if (physical.includes(vendor)) {
            routeType = 'physical';
        } else if (virtual.includes(vendor)) {
            routeType = 'virtual';
        }

        return routeType;
    }

    setRoute(currentRoute) {
        const vendor = currentRoute.toUpperCase();
        const routeType = this.getRouteType(vendor);
        this.handleForeign(vendor);

        switch (routeType) {
            case 'virtual':
                this.setState({
                    currentRoute: currentRoute,
                    vendor: vendor,
                    currFields: accountForm.virtualFormFields(),
                });
                break;

            case 'physical':
                this.setState({
                    currentRoute: currentRoute,
                    vendor: vendor,
                    currFields: accountForm.physicalFormFields(),
                });
                break;

            default:
                this.setState({
                    currentRoute: currentRoute,
                    vendor: vendor,
                    currFields: accountForm.allFormFields
                });
        }
    }

    updateFormFields = (newLocation) => {
        let initPath = newLocation || this.props.location.pathname;
        let initRoute = this.getRoute(initPath);

        this.setRoute(initRoute);
    }

    handlePopulate = (e) => {
        const clonePrepopdata = Object.assign({}, preData);

        this.setState({
            formValues: clonePrepopdata
        });
    }

    handleReset = () => {
        this.handleResetForm();
        this.props.history.push('');
    }

    handleResetPage = (e, adv) => {
        e.stopPropagation();
        const { currentRoute, vendor } = this.state
        const routeType = this.getRouteType(vendor);

        switch (routeType) {
            case 'virtual':
                this.setState({
                    [vendor]: accountForm.virtualFields,
                });
                break;

            case 'physical':
                this.setState({
                    [vendor]: accountForm.physicalFields,
                });
                break;

            default:
                const updatedState = Object.assign(this.state[vendor], accountForm.advFields);

                if (adv) {
                    this.setState({
                        [vendor]: updatedState,
                        isAdvance: false
                    });
                } else {
                    this.setState({
                        [vendor]: accountForm.allFields
                    });
                }
        }
    }

    handleResetForm = () => {
        this.setState({
            hasError: false,
            isLoading: false,
            isCharged: false,
            isSubmitted: false,
            isTransitioned: false,
            prevRoute: '',
            currFields: accountForm.allFormFields,
            formValues: accountForm.initialForm,
            ...accountForm.initialForm
        });
    }

    handleForeign = (vendor) => {
        if (this.state[vendor][ff.TRANS_CURRENCY] !== "USD" && this.state[vendor][ff.TRANS_CURRENCY] !== "") {
            this.setState({
                isForeign: true
            });
        } else if (this.state[vendor][ff.TRANS_CURRENCY] === "USD" || this.state[vendor][ff.TRANS_CURRENCY] === "") {
            const updatedState = { ...this.state[vendor], [ff.TRANS_CONVERSION_RATE]: "" };
            this.setState({
                isForeign: false,
                [vendor]: updatedState
            });
        }
    }

    handleUpdate = (e, value, field) => {
        const { currentRoute } = this.state;
        const vendor = currentRoute.toUpperCase();
        const updatedState = { ...this.state[vendor], [field]: value };

        this.setState({
            [vendor]: updatedState
        }, () => this.updateFormFields());
    }

    handleValidation = (e) => {
        const { vendor } = this.state;
        const requiredFields = [
            ff.AUTH_CARD_NUMBER,
            ff.AUTH_ZIPCODE,
            ff.AUTH_EXPIRATION_DATE,
            ff.TRANS_AMOUNT,
        ];
        let errors = {};

        _.forEach(this.state[vendor], (val, key) => {
            if (!requiredFields.includes(key)) {
                return;
            } else {
                switch (key) {
                    case ff.TRANS_AMOUNT:
                        if (val === '') {
                            errors[key] = 'Required';
                        }
                        break;
                    case ff.AUTH_CARD_NUMBER:
                        const sixChars = val.substr(0, 6);
                        const validBins = ['511913', '526876', '528888', '514180', '557306', '523010', '555722','555823','515434','516077','524642'];

                        if (val.length < 1) {
                            errors[key] = 'Required';
                        } else if (!validBins.includes(sixChars) || val.length !== 16) {
                            errors[key] = 'Invalid response';
                        } else if (this.state.customErrors) {
                            this.setState({
                                customErrors: null
                            });
                        }
                        // else format is correct and a debounced method to check account number should be issued
                        break;
                    case ff.AUTH_CVV:
                        if (!utils.CVVIsValid(val)) {
                            errors[key] = 'Invalid response';
                        }
                        break;
                    case ff.AUTH_EXPIRATION_DATE:
                        if (val.length < 1) {
                            errors[key] = 'Required';
                        } else if (!utils.expirationIsValid(val, 'MM/YY')) {
                            errors[key] = 'Invalid response';
                        }
                        break;
                    case ff.AUTH_ZIPCODE:
                        if (val.length < 1) {
                            errors[key] = 'Required';
                        } else if (!utils.zipCodeIsValid(val) || typeof val !== 'string') {
                            errors[key] = 'Invalid response';
                        }
                        break;
                    case ff.MERCH_STATE:
                        if (val.length < 1) {
                            errors[key] = 'Invalid response';
                        }
                        break;
                    default:
                        if (!val || val === "" || val === " ") {
                            errors[key] = 'Required';
                        }
                        break;
                }
            }
        });

        return errors;
    }

    authAcct = async (cc) => {
        try {
            const { data } = await this.props.getAccount(cc);
            // update acct info
        } catch (err) {
            return err;
        }
    }

    handleSubmit = async (e) => {
        if (e) e.preventDefault();
        const {
            updateAccount
        } = this.props;
        const { vendor, isAdvance } = this.state;
        const AcctNum = this.state[vendor][ff.AUTH_CARD_NUMBER];
        const PaymentType = this.state[VN.CUSTOM][ff.AUTH_PAYMENT_TYPE];

        if (this.getRouteType(vendor) !== 'virtual' && PaymentType !== 'VIRTUAL') {
            this.setState({
                showPinModal: true
            });
        } else {
            this.handleCharge();
        }

        // try {
        //     let acctRes;
        //     if (process.env.NODE_ENV !== 'development') {
        //         acctRes =  await this.props.getAccount(AcctNum);
        //         updateAccount(acctRes);

        //         if (!acctRes.success) {
        //             this.setState({
        //                 isLoading: false,
        //                 customErrors: {[ff.AUTH_CARD_NUMBER]: 'Invalid Card Number'}
        //             });
        //         } else {
        //             this.setState({
        //                 showPinModal: true,
        //                 isLoading: false,
        //             });
        //         }
        //     } else {
        //         const { data } = await this.props.getAccount(AcctNum);
        //         acctRes = data;
        //         updateAccount(data);

        //         if (!data.success) {
        //             this.setState({
        //                 isLoading: false,
        //                 customErrors: {[ff.AUTH_CARD_NUMBER]: 'Invalid Card Number'}
        //             });
        //         } else {
        //             this.setState({
        //                 showPinModal: true,
        //                 isLoading: false,
        //             });
        //         }
        //     }

        // } catch (err) {
        //     console.log(err)
        //     this.setState({
        //         isLoading: false,
        //         customErrors: {[ff.AUTH_CARD_NUMBER]: 'Invalid Card Number'}
        //     });
        // }
    }

    handleCharge = async () => {
        const {
            updateTransaction,
            createTransaction
        } = this.props;

        const { vendor, isAdvance, isPreAuth } = this.state;
        const AcctNum = this.state[vendor][ff.AUTH_CARD_NUMBER];

        this.setState({
            isLoading: true,
        });

        try {
            let transactionRes;

            if (process.env.NODE_ENV !== 'development') {
                transactionRes = await createTransaction(this.state[vendor], {
                    vendorName: vendor,
                    isAdvance: isAdvance,
                    isPreAuth: isPreAuth
                });
            } else {
                const { data } = await createTransaction(this.state[vendor], {
                    vendorName: vendor,
                    isAdvance: isAdvance,
                    isPreAuth: isPreAuth
                });
                transactionRes = data;
            }

            if (!transactionRes.success) {
                const errorMessage = _.get(transactionRes, 'error.message', 'Invalid Transaction Request');
                this.props.errorValue.renderError(errorMessage);
            }

            this.setState({
                showPinModal: false,
                isLoading: false,
                isSubmitted: true,
            });

            updateTransaction(transactionRes);
        } catch (err) {
            this.props.errorValue.renderError(err.message);
            this.setState({
                showPinModal: false,
                isLoading: false,
                isSubmitted: true,
            });
        }
    }

    openModal = () => {
        this.setState({
            showModal: true
        });
    }

    closeModal = () => {
        this.setState({
            showModal: false
        });
    }

    setAdvanced = (val) => {
        this.setState({
            isAdvance: val
        });
    }

    renderLoader() {
        const largeSize = '80px';

        return (
            <LoaderWrapper isLoading={this.state.isLoading}>
                <SvgIcons.synapse_circle_logo color={Colors.ARSENIC} size={largeSize} rotate_ccw_normal />
            </LoaderWrapper>
        )
    }

    render() {
        const { transactionData, history, location, updateTransaction } = this.props;
        const { isSubmitted, isLoading, formValues, showAddressField, showSubmit, showModal, showPinModal, isForeign, isPreAuth } = this.state;
        // redirect logic
        const currRoute = this.getRoute(location.pathname);
        let vendor = currRoute.toUpperCase();
        if (!VN.VENDORS.includes(vendor)) {
            vendor = VN.CUSTOM
            history.push('')
        }

        const vendorForm = this.state[vendor];
        //response values
        const accountNum = _.get(vendorForm, `${ff.AUTH_CARD_NUMBER}`, '');
        const transactionID = _.get(transactionData, `synapse_transaction_id`, '');
        const transStatus = _.get(transactionData, `success`, false);
        const settlementValue = _.get(transactionData, `data.amount.settlement_value`, false);
        const isPreAuthVendor = vendor === VN.CUSTOM || vendor === VN.RESTAURANT;

        return (
            <React.Fragment>
                {
                    (!isSubmitted && !isLoading) &&
                    <HeaderText
                        margin="0px 0px 0px 5px"
                    >
                        Virtual Terminal
                    </HeaderText>
                }
                {isLoading && this.renderLoader()}
                <AccountFormContainer
                    isLoading={this.state.isLoading}
                    isSubmitted={isSubmitted}
                >
                    {
                        !isLoading && !isSubmitted &&
                        <Fragment>
                            <AccountSideNav
                                history={history}
                                location={location}
                            />
                            <CSSTransition
                                classNames="fade"
                                in={this.state.isTransitioned}
                                timeout={500}
                                onEnter={() => this.setState({ isTransitioned: false })}
                            >
                                <AccountFormGrid>
                                    {
                                        vendor !== VN.CUSTOM &&
                                        <BrandSection
                                            currRoute={currRoute}
                                        />
                                    }
                                    <StyledForm
                                        isForeign={this.state.isForeign}
                                        // autocomplete="off"
                                        vendor={vendor}
                                        key={"form"}
                                        ref={this.form}
                                        errors={this.state.customErrors}
                                        showSubmit={showSubmit}
                                        data={this.state.currFields}
                                        formValues={this.state[vendor]}
                                        btnObjs={
                                            [
                                                ...(isPreAuthVendor && [{
                                                    type: 'submit',
                                                    style: 'secondary',
                                                    className: `Button__Submit`,
                                                    text: 'Pre-Authorize',
                                                    onClick: ()=> this.setPreAuth(true)
                                                }]) || [],
                                                {
                                                    type: 'submit',
                                                    style: 'primary',
                                                    className: `Button__Submit`,
                                                    text: 'Authorize',
                                                }
                                            ]
                                        }
                                        validation={this.handleValidation}
                                        onChange={this.handleUpdate}
                                        handleSubmit={this.handleSubmit}
                                        isLoading={this.state.isLoading}
                                    >
                                        {
                                            accountForm.allformChildren(this.state, this.handleUpdate, vendor)
                                        }
                                        {
                                            vendor === VN.CUSTOM && accountForm.formChildren(this.state, this.handleUpdate)
                                        }
                                        <ModalForm
                                            setAdvanced={this.setAdvanced}
                                            handleResetPage={this.handleResetPage}
                                            isForeign={isForeign}
                                            isOpen={showModal}
                                            state={this.state[vendor]}
                                            handleUpdate={this.handleUpdate}
                                            closeModal={this.closeModal}
                                        />
                                    </StyledForm>
                                    {
                                        vendor === VN.CUSTOM && <ButtonGroup>
                                            <AnchorText
                                                onClick={this.openModal}
                                            >
                                                Advanced
                                            </AnchorText>
                                        </ButtonGroup>
                                    }
                                </AccountFormGrid>
                            </CSSTransition>
                        </Fragment>
                    }
                    {
                        isSubmitted && !isLoading &&
                        <AccountResponse
                            // handleNewPayment={this.handleReset}
                            // status={'Payment Successful'}
                            // isPreAuth={true}
                            // setPreAuth={this.setPreAuth}
                            // isPartial={settlementValue ? true : false}
                            // amount={settlementValue ? settlementValue : vendorForm[ff.TRANS_AMOUNT]}
                            // currency={vendorForm[ff.TRANS_CURRENCY]}
                            // transactionID={'1231231231adfadf'}
                            // accountNum={accountNum}
                            updateTransaction={updateTransaction}
                            handleNewPayment={this.handleReset}
                            status={transStatus ? 'Payment Successful' : 'Payment failed'}
                            isPreAuth={isPreAuth}
                            setPreAuth={this.setPreAuth}
                            isPartial={settlementValue ? true : false}
                            amount={settlementValue ? settlementValue : vendorForm[ff.TRANS_AMOUNT]}
                            transactionID={transactionID}
                            accountNum={accountNum}
                        />
                    }
                </AccountFormContainer>

                {showPinModal &&
                    <PinModal
                        isOpen={showPinModal}
                        onChange={(e, code) => this.handleUpdate(e, code, ff.AUTH_PIN)}
                        closeModal={() => this.setState({ showPinModal: false })}
                        onSubmit={(code) => this.handleCharge()}
                    />
                }
            </React.Fragment>
        )
    }
}

export default withRouter(AccountForm);